<template>
  <div>
    <search-agent-statistics
      @submit="submitSearch"
      :agent-id="agentId"
    />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData" style="display: none;">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      @change="sortChange"
      row-key="id"
    >
      <div slot="name" slot-scope="name, record">
        <a-tooltip color="#FFFFFF">
          <template slot="title">
            <finance-monthly-inc-chart
              style="height: 200px; width: 1000px;"
              :id="record.id"
            />
          </template>
          <div v-if="isShowMenu('agents/show')">
            <router-link :to="'/agents/' + record.agent_id + '/info'"> {{ name }} </router-link>
          </div>
          <div v-else>{{ name }}</div>
        </a-tooltip>
      </div>

      <div slot="totalFee" slot-scope="total_fee, record">
        <a-tooltip>
          <template slot="title">
            <div>采购金额：{{ record.purchased_fee | formatCurrency }} 元</div>
            <div>激活金额：{{ record.actived_fee | formatCurrency }} 元</div>
            <div>续期金额：{{ record.renewed_fee | formatCurrency }} 元</div>
            <div>订购金额：{{ record.subscribed_fee | formatCurrency }} 元</div>
            <div>停机保号金额：{{ record.stopped_fee | formatCurrency }} 元</div>
            <div>流量使用金额：{{ record.card_used_fee | formatCurrency }} 元</div>
          </template>
          <div class="tip-item">
            {{ total_fee | formatCurrency }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalFeeInc1" slot-scope="total_fee_inc1, record">
        <a-tooltip>
          <template slot="title">
            <div>采购金额：{{ record.purchased_fee_inc1 | formatCurrency }} 元</div>
            <div>激活金额：{{ record.actived_fee_inc1 | formatCurrency }} 元</div>
            <div>续期金额：{{ record.renewed_fee_inc1 | formatCurrency }} 元</div>
            <div>订购金额：{{ record.subscribed_fee_inc1 | formatCurrency }} 元</div>
            <div>停机保号金额：{{ record.stopped_fee_inc1 | formatCurrency }} 元</div>
            <div>流量使用金额：{{ record.card_used_fee_inc1 | formatCurrency }} 元</div>
          </template>
          <div class="tip-item">
            {{ total_fee_inc1 | formatCurrency }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalFeeInc3" slot-scope="total_fee_inc3, record">
        <a-tooltip>
          <template slot="title">
            <div>采购金额：{{ record.purchased_fee_inc3 | formatCurrency }} 元</div>
            <div>激活金额：{{ record.actived_fee_inc3 | formatCurrency }} 元</div>
            <div>续期金额：{{ record.renewed_fee_inc3 | formatCurrency }} 元</div>
            <div>订购金额：{{ record.subscribed_fee_inc3 | formatCurrency }} 元</div>
            <div>停机保号金额：{{ record.stopped_fee_inc3 | formatCurrency }} 元</div>
            <div>流量使用金额：{{ record.card_used_fee_inc3 | formatCurrency }} 元</div>
          </template>
          <div class="tip-item">
            {{ total_fee_inc3 | formatCurrency }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalFeeInc6" slot-scope="total_fee_inc6, record">
        <a-tooltip>
          <template slot="title">
            <div>采购金额：{{ record.purchased_fee_inc6 | formatCurrency }} 元</div>
            <div>激活金额：{{ record.actived_fee_inc6 | formatCurrency }} 元</div>
            <div>续期金额：{{ record.renewed_fee_inc6 | formatCurrency }} 元</div>
            <div>订购金额：{{ record.subscribed_fee_inc6 | formatCurrency }} 元</div>
            <div>停机保号金额：{{ record.stopped_fee_inc6 | formatCurrency }} 元</div>
            <div>流量使用金额：{{ record.card_used_fee_inc6 | formatCurrency }} 元</div>
          </template>
          <div class="tip-item">
            {{ total_fee_inc6 | formatCurrency }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalFeeInc12" slot-scope="total_fee_inc12, record">
        <a-tooltip>
          <template slot="title">
            <div>采购金额：{{ record.purchased_fee_inc12 | formatCurrency }} 元</div>
            <div>激活金额：{{ record.actived_fee_inc12 | formatCurrency }} 元</div>
            <div>续期金额：{{ record.renewed_fee_inc12 | formatCurrency }} 元</div>
            <div>订购金额：{{ record.subscribed_fee_inc12 | formatCurrency }} 元</div>
            <div>停机保号金额：{{ record.stopped_fee_inc12 | formatCurrency }} 元</div>
            <div>流量使用金额：{{ record.card_used_fee_inc12 | formatCurrency }} 元</div>
          </template>
          <div class="tip-item">
            {{ total_fee_inc12 | formatCurrency }}
          </div>
        </a-tooltip>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import SearchAgentStatistics from '@/views/agent_statistics/Search'
import FinanceMonthlyIncChart from '@/views/agent_statistics/FinanceMonthlyIncChart'
import Pagination from '@/components/Pagination'
import { hasPermission } from '@/utils/permission'
import { findAgentStatisticsFinance, exportAgentStatisticsFinance } from '@/api/agent_statistics'
import { exportExcel } from '@/api/excel'
import { formatCurrency } from '@/utils/filter'
export default {
  name: 'AgentStatisticsFinance',
  components: {
    SearchAgentStatistics,
    FinanceMonthlyIncChart,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '客户名称',
          dataIndex: 'name',
          fixed: 'left',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '截止月份',
          dataIndex: 'month'
        },
        {
          title: '累计销售额(元)',
          dataIndex: 'total_fee',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalFee' }
        },
        {
          title: '近1月销售额(元)',
          dataIndex: 'total_fee_inc1',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee_inc1' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalFeeInc1' }
        },
        {
          title: '近3月销售额(元)',
          dataIndex: 'total_fee_inc3',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee_inc3' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalFeeInc3' }
        },
        {
          title: '近6月销售额(元)',
          dataIndex: 'total_fee_inc6',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee_inc6' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalFeeInc6' }
        },
        {
          title: '近12月销售额(元)',
          dataIndex: 'total_fee_inc12',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee_inc12' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalFeeInc12' }
        },
        {
          title: '责任销售',
          dataIndex: 'sales_full_names'
        }
      ]
    },
    agentId() {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    formatCurrency,
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findAgentStatisticsFinance(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    exportData() {
      exportAgentStatisticsFinance(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

<style>
.ant-tooltip {
  max-width: 1010px;
}
</style>
